import { getFirestore, collection, addDoc } from "firebase/firestore";

const createGrading = async (branchId) => {
  const db = getFirestore();

  try {
    const defaultGradingData = {
      branchId: branchId,
      grade1: {
        grade: 200,
        icon: "A",
        value: "A",
      },
      grade2: {
        grade: 100,
        icon: "B",
        value: "B",
      },
      grade3: {
        grade: -100,
        icon: "C",
        value: "C",
      },
      grade4: {
        grade: -200,
        icon: "D",
        value: "D",
      },
      weights: {
        Asbeza: 1,
        Card: 1,
        CardFee: 1,
        cardDistribute: 1,
        hotelProfit: 1,
        Water: 1,
        waterDistribute: 1,
        Wifi: 1,
        wifiDistribute: 1,
      },
    };

    // Add the document to the grading collection
    const docRef = await addDoc(collection(db, "grading"), defaultGradingData);

    return {
      id: docRef.id,
      ...defaultGradingData,
    };
  } catch (error) {
    console.error("Error creating grading:", error);
    throw error;
  }
};

export default createGrading;
